// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vr6Zd{height:18rem;position:relative;width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `Vr6Zd`
};
module.exports = ___CSS_LOADER_EXPORT___;
